import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { GroupService } from '@ascschool/services/user/group.service';
import { Group } from '@ascschool/model/user/group.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Observable } from 'rxjs';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { GroupSchoolService } from '@ascschool/services/user/group-schools.service';
import { map } from 'rxjs/operators';
import { ButtonType } from '@ascschool/interface/setting';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { ChangeDetectorRef } from '@angular/core';
import { Level } from '@ascschool/model/category/level.model';

@Component({
  selector: 'app-quan-ly-danh-sach-co-so',
  templateUrl: './quan-ly-danh-sach-co-so.component.html',
  styleUrls: ['./quan-ly-danh-sach-co-so.component.scss']
})
export class QuanLyDanhSachCoSoComponent implements OnInit {
  @Input() dataTransmission: any;
  searchAdvanced: boolean = false;
  loading: boolean = false;
  firstRowOnPage: number = 0; 
  listGroupSelected: number[] = [];
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize = this.pageSizeOptions[2];
  searchForm: FormGroup;
  schoolList: any; 
  pageIndex: number = 1; 

  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
 
  getDistrictACFn: (value: any) => Observable<any>;
  districtSubscription: any;
  districtControl = new FormControl();
  getProvinceACFn: (value: any) => Observable<any>;
  provinceSubscription: any;
  provinceControl = new FormControl();
  getTypeOfSchoolACFn: (value: any) => Observable<any>;
  typeofschoolSubscription: any;
  typeofschoolControl = new FormControl();
  getSchoolLevelACFn: (value: any) => Observable<any>;
  schoollevelSubscription: any;
  schoollevelControl = new FormControl();
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = ''; 
  categoryModel = new CategoryModel();  
  Total: number = 0;  
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef; 
 
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public sizePageService: SizePageService,
   public utilsService: UtilsService,
    private provinceService: ProvinceService,
    private districtService: DistrictService,
    private schoollevelService : SchoolLevelService,
    private typeofschoolService: TypeOfSchoolService,
    private schoolService: SchoolService,
    private service : GroupSchoolService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    
    
    
    const currentUser = JSON.parse(localStorage.getItem('userSetting'));
    //this.commonFilter.ProvinceId = currentUser.provinceId; 
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[2];
    this.loadList();
    this.loadProvince();
    this.loadTypeOfSchool();
    this.loadSchoolLevel(); 
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.loadList();
  }
  loadList() {
    this.loading = true;
    this.schoolList = []; 
    
    this.commonFilter.GroupId = this.dataTransmission.id;
    this.schoolService.getSelectPagingGroupSchoolManage(this.commonFilter).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = (response && response.rowCount) ? response.rowCount : 0;
        this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
        this.schoolList = (list) ? list : [];
        this.loading = false;
      },
      (err: any) => {
        this.schoolList = [];
        this.loading = false;
      }
    );
  }

  Update() {
    this.setOfCheckedId.forEach(item => {
      this.listGroupSelected.push(item);
    });
    if(this.listGroupSelected.length > 0){ 
      if(this.dataTransmission.id && this.dataTransmission.id != null){ 
        this.service.addMultipleQuyen({groupId: this.dataTransmission.id, listSchoolId: this.listGroupSelected}).subscribe((res)=>{
          if(res.statusCode == 0){
            this.utilsService.notifyResponse(res);
            this.close();
          }
          else{
            this.utilsService.notifyResponse(res);
          }
        })
      }
    }else{
      this.msg.warning('Vui lòng chọn cơ sở quản lý');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.loadList();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.loadList();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard 
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingPermisstion({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.provinceSubscription) this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
    });
  }

  changeProvince(control: FormControl) {
    this.provinceControl = control; 
    this.loadDistrict();
    this.districtControl.setValue(null);
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.districtSubscription) this.districtSubscription = this.districtControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
    });
  }

  changeDistrict(control: FormControl) {
    this.districtControl = control;
  }

  loadTypeOfSchool() {
    this.getTypeOfSchoolACFn = (value: any) => this.typeofschoolService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.typeofschoolSubscription) this.typeofschoolSubscription = this.typeofschoolControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'TypeOfSchoolId', this.typeofschoolControl.value);
    });
  }

  changeTypeOfSchool(control: FormControl) {
    this.typeofschoolControl = control;
  }

  loadSchoolLevel() {
    this.getSchoolLevelACFn = (value: any) => this.schoollevelService.getSchoolLevelsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.schoollevelSubscription) this.schoollevelSubscription = this.schoollevelControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'SchoolLevelId', this.schoollevelControl.value);
    });
  }

  changeSchoolLevel(control: FormControl) {
    this.schoollevelControl = control;
  }
  

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
}
